var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { widgetMetricCellBadgeDiff, widgetMetricCellInvisibleBadgeSlot, widgetMetricCellThreeColDiff, widgetMetricTableDiffTdClass, widgetMetricTableFigureValueSpanClass, widgetMetricTablePeriodDiffBeforeTeamTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import BadgeDiff from '@web/components/ui/Badge/BadgeDiff';
import { TablesDiffColorsConfig } from '@web/config';
import { classNames } from '@web/utility';
export function metricTablePeriodDiffRowCell(id, diff, arrowColor, className, options) {
    var _a;
    if (className === void 0) { className = widgetMetricTableDiffTdClass; }
    var innerJustify = (_a = options === null || options === void 0 ? void 0 : options.innerJustify) !== null && _a !== void 0 ? _a : 'start';
    return {
        id: id,
        className: className,
        render: function () { return (_jsx("div", __assign({ className: classNames('flex w-full min-w-0 pl-0 pr-0', innerJustify === 'end' ? 'justify-end' : 'justify-start') }, { children: _jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: diff != null ? (_jsx(BadgeDiff, { diffValue: diff, customStyles: widgetMetricCellBadgeDiff, arrowColor: arrowColor })) : (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) })) }))); }
    };
}
export function metricTableStackedDiffsRowCell(id, periodDiff, teamDiff, showTeamDiff, isSecondaryDiffHidden, className) {
    if (className === void 0) { className = widgetMetricTableDiffTdClass; }
    return {
        id: id,
        className: className,
        render: function () { return (_jsx("div", __assign({ className: "flex w-full min-w-0 justify-start pl-0 pr-0" }, { children: _jsxs("div", __assign({ className: "flex flex-col items-start gap-0.5" }, { children: [_jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: periodDiff != null ? (_jsx(BadgeDiff, { diffValue: periodDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.GREEN })) : (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) })), showTeamDiff ? (_jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: isSecondaryDiffHidden ? (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) : teamDiff != null ? (_jsx(BadgeDiff, { diffValue: teamDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE })) : (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) }))) : null] })) }))); }
    };
}
export function metricTableTeamAvgDiffRowCell(id, secondaryDiff, isSecondaryDiffHidden, className) {
    if (className === void 0) { className = widgetMetricTableDiffTdClass; }
    return {
        id: id,
        className: className,
        render: function () { return (_jsx("div", __assign({ className: "flex w-full min-w-0 justify-start pl-0 pr-0" }, { children: _jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: isSecondaryDiffHidden ? (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) : secondaryDiff != null ? (_jsx(BadgeDiff, { diffValue: secondaryDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE })) : (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) })) }))); }
    };
}
export function metricTableInvocationsTimeSpentRow(rowKey, label, metrics, options) {
    var showTeamDiff = options.showTeamDiff, isSecondaryDiffHidden = options.isSecondaryDiffHidden, isTotalRow = options.isTotalRow, onNavigate = options.onNavigate;
    var periodTd = showTeamDiff
        ? widgetMetricTablePeriodDiffBeforeTeamTdClass
        : undefined;
    var periodOpts = showTeamDiff
        ? { innerJustify: 'end' }
        : undefined;
    var metricCells = function (suffix, value, prevDiff, teamDiff) {
        var cells = [
            {
                id: "".concat(rowKey, "-").concat(suffix, "-value"),
                className: classNames(widgetMetricTableValueTdClass, onNavigate && 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, onNavigate && 'cursor-pointer'), onClick: onNavigate }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: value })) }))); }
            },
            metricTablePeriodDiffRowCell("".concat(rowKey, "-").concat(suffix, "-period"), prevDiff, TablesDiffColorsConfig.GREEN, periodTd, periodOpts)
        ];
        if (showTeamDiff) {
            cells.push(metricTableTeamAvgDiffRowCell("".concat(rowKey, "-").concat(suffix, "-team"), teamDiff, isSecondaryDiffHidden));
        }
        return cells;
    };
    return __spreadArray(__spreadArray([
        {
            id: "".concat(rowKey, "-label"),
            className: classNames(widgetMetricTablePrimaryLabelTdClass, onNavigate && 'cursor-pointer'),
            render: function () { return (_jsx("div", __assign({ className: classNames('min-w-0 max-w-full break-words', isTotalRow ? 'font-bold' : 'font-semibold', onNavigate && 'cursor-pointer'), onClick: onNavigate }, { children: label }))); }
        }
    ], metricCells('invocations', metrics.invocations.count, metrics.invocations.prevPeriodDiff, metrics.invocations.teamAvgDiff), true), metricCells('timeSpent', metrics.timeSpent.formatted, metrics.timeSpent.prevPeriodDiff, metrics.timeSpent.teamAvgDiff), true);
}
